const park = {
    managers: {
        CREATE: 'add_client',
        READ: 'view_client',
        UPDATE: 'change_client',
        DELETE: 'delete_client',
    },

    clients: {
        CREATE: 'add_sitecustomer',
        READ: 'view_sitecustomer',
        UPDATE: 'change_sitecustomer',
        DELETE: 'delete_sitecustomer',
    },

    sites: {
        CREATE: 'add_site',
        READ: 'view_site',
        UPDATE: 'change_site',
        DELETE: 'delete_site',
    },
}

const machines = {
    all: {
        READ: 'view_machine',
        UPDATE: 'change_machine',
        CREATE: 'add_machine',
        DELETE: 'delete_machine',
    },

    machineOptions: {
        CREATE: 'add_machineoption',
        READ: 'view_machineoption',
        UPDATE: 'change_machineoption',
        DELETE: 'delete_machineoption',
    },

    machineRelations: {
        CREATE: 'add_machinegrid',
        READ: 'view_machinegrid',
        UPDATE: 'change_machinegrid',
        DELETE: 'delete_machinegrid',
    },

    marketingImages: {
        CREATE: 'add_marketingimage',
        READ: 'view_marketingimage',
        UPDATE: 'change_marketingimage',
        DELETE: 'delete_marketingimage',
    },

    marketingVideos: {
        CREATE: 'add_marketingvideo',
        READ: 'view_marketingvideo',
        UPDATE: 'change_marketingvideo',
        DELETE: 'delete_marketingvideo',
    },

    technicalData: {
        CREATE: 'add_technicaldata',
        READ: 'view_technicaldata',
        UPDATE: 'change_technicaldata',
        DELETE: 'delete_technicaldata',
    },

    planograms: {
        CREATE: 'add_machinegriditem',
        READ: 'view_machinegriditem',
        UPDATE: 'change_machinegriditem',
        DELETE: 'delete_machinegriditem',
    },

    stock: {
        READ: 'view_stock',
    },
}

const catalogue = {
    suppliers: {
        CREATE: 'add_supplierproduct',
        READ: 'view_supplierproduct',
        UPDATE: 'change_supplierproduct',
        DELETE: 'delete_supplierproduct',
    },

    products: {
        CREATE: 'add_product',
        READ: 'view_product',
        UPDATE: 'change_product',
        DELETE: 'delete_product',
    },

    discounts: {
        CREATE: 'add_discount',
        READ: 'view_discount',
        UPDATE: 'change_discount',
        DELETE: 'delete_discount',
    },

    discountsPriority: {
        CREATE: 'add_discountpriority',
        READ: 'view_discountpriority',
        UPDATE: 'change_discountpriority',
        DELETE: 'delete_discountpriority',
    },

    priceTable: {
        CREATE: 'add_pricetable',
        READ: 'view_pricetable',
        UPDATE: 'change_pricetable',
        DELETE: 'delete_pricetable',
    },

    priceLine: {
        CREATE: 'add_priceline',
        READ: 'view_priceline',
        UPDATE: 'change_priceline',
        DELETE: 'delete_priceline',
    },
}

const transactions = {
    sales: {
        READ: 'view_sale',
    },

    disputes: {
        READ: 'view_dispute',
    },

    disputedProducts: {
        READ: 'view_disputeproduct',
    },

    refunds: {
        READ: 'view_refund',
    },

    refills: {
        READ: 'view_creditrefill',
    },
}

const operations = {
    deliveries: {
        READ: 'view_delivery',
    },

    interventions: {
        READ: 'view_intervention',
    },

    incidents: {
        READ: 'view_event',
    },

    encodedProducts: {
        READ: 'view_encodingreport',
    },

    destocking: {
        DELETE: 'delete_encodedproduct',
        READ: 'view_encodedproduct',
    },
}

const users = {
    profiles: {
        CREATE: 'add_group',
        READ: 'view_group',
        UPDATE: 'change_group',
        DELETE: 'delete_group',
    },

    konsole: {
        CREATE: 'add_user',
        READ: 'view_user',
        UPDATE: 'change_user',
        DELETE: 'delete_user',
    },

    technicians: {
        CREATE: 'add_technician',
        READ: 'view_technician',
        UPDATE: 'change_technician',
        DELETE: 'delete_technician',
    },

    deliveryMen: {
        CREATE: 'add_deliveryman',
        READ: 'view_deliveryman',
        UPDATE: 'change_deliveryman',
        DELETE: 'delete_deliveryman',
    },

    konvives: {
        CREATE: 'add_machineuser',
        READ: 'view_machineuser',
        UPDATE: 'change_machineuser',
        DELETE: 'delete_machineuser',
    },
}

const settings = {
    theme: {
        CREATE: 'add_colorsparameters',
        READ: 'view_colorsparameters',
        UPDATE: 'change_colorsparameters',
    },

    managerCategories: {
        CREATE: 'add_categoryclient',
        READ: 'view_categoryclient',
        UPDATE: 'change_categoryclient',
        DELETE: 'delete_categoryclient',
    },

    siteTypes: {
        CREATE: 'add_sitetype',
        READ: 'view_sitetype',
        UPDATE: 'change_sitetype',
        DELETE: 'delete_sitetype',
    },

    zones: {
        CREATE: 'add_zone',
        READ: 'view_zone',
        UPDATE: 'change_zone',
        DELETE: 'delete_zone',
    },

    allergens: {
        CREATE: 'add_allergens',
        READ: 'view_allergens',
        UPDATE: 'change_allergens',
        DELETE: 'delete_allergens',
    },

    productCategories: {
        CREATE: 'add_categoryproduct',
        READ: 'view_categoryproduct',
        UPDATE: 'change_categoryproduct',
        DELETE: 'delete_categoryproduct',
    },

    subcategoryProducts: {
        CREATE: 'add_subcategoryproduct',
        READ: 'view_subcategoryproduct',
        UPDATE: 'change_subcategoryproduct',
        DELETE: 'delete_subcategoryproduct',
    },

    email: {
        CREATE: 'add_emailparameter',
        READ: 'view_emailparameter',
        UPDATE: 'change_emailparameter',
    },

    ticket: {
        CREATE: 'add_ticketparameter',
        READ: 'view_ticketparameter',
        UPDATE: 'change_ticketparameter',
    },
}

export const permissions = {
    park,
    machines,
    catalogue,
    transactions,
    operations,
    users,
    settings,
}
